
import { defineComponent, computed, inject } from 'vue';
import { useVModel } from 'vue-composable';
import { Survey } from '@/types';
import surveyService from '@/services/survey-service';
import { ShowToast } from '@/providers/Toast/toast-types';

export default defineComponent({
  name: 'ConfirmShareableChangeModal',
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    survey: {
      type: Object as () => Survey | null,
      required: true
    }
  },
  setup(props, { emit }) {
    const surveyRef = computed(() => props.survey);
    const showModalRef = useVModel(props, 'showModal');
    const showToast = inject<ShowToast>('showToast')!;

    const closeModal = () => {
      emit('resetShareable');
      showModalRef.value = false;
    };

    const confirmShareableChange = async () => {
      if (!surveyRef.value) return;
      const response = await surveyService.update({ ...surveyRef.value, shareable: !surveyRef.value.shareable });

      let messageText = '';
      if (response) {
        messageText = surveyRef.value.shareable ? 'Survey is now private' : 'Survey is now shareable';
        showToast({
          headline: 'Success',
          message: messageText,
          color: 'success'
        });

        emit('updateSurvey', surveyRef.value);
        surveyRef.value.shareable = !surveyRef.value.shareable;
        closeModal();
      } else {
        messageText = surveyRef.value.shareable ? 'Failed to make survey shareable' : 'Failed to make survey private';
        showToast({
          headline: 'Error',
          message: messageText,
          color: 'danger'
        });
        closeModal();
      }
    };
    return {
      surveyRef,
      closeModal,
      confirmShareableChange,
      showModalRef
    };
  }
});
